// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs"

import filterConsoleErrors from "~/@shared/utils/filterConsoleErrors"
import { SENTRY_IGNORE_ERRORS } from "~/consts"

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN

Sentry.init({
  dsn: SENTRY_DSN || "https://d7ccca0683e541c089531d36680822cf@o170364.ingest.sentry.io/1797914",
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.1,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  environment: process.env.ENV,
  beforeSend: filterConsoleErrors,
  ignoreErrors: SENTRY_IGNORE_ERRORS,
})
